export default {
	default_pre_title: "Singapore Digital Experience Agency",
	post_title: "Onyx Island",
	title_separator: " | ",
	site_description:"Onyx Island is a HubSpot Diamond Solutions Partner specialising in MarTech, CRM implementation, CMS development, social media marketing & creative services.",
	meta_image: `https://${(typeof location != 'undefined' ? location?.hostname : null) ?? process.env.HOSTNAME ?? 'localhost'}${require("../../assets/logo-portrait-bw.jpg")}`,
}; 